<template>
  <div class="item-frame">
    <p style="font-size: 0.5rem">↓↓stg/devのみ表示↓↓</p>
    <input
      id="setting-item-1"
      type="checkbox"
      class="checkbox"
      @click="toggle = !toggle"
    />
    <label class="switch" for="setting-item-1"></label>
    <label class="text" style="font-weight: bold" for="setting-item-1"
      >エリア制限あり</label
    >
  </div>
</template>

<script>
import { useVModel } from "vue-composable";

export default {
  name: "AreaValidationToggle",
  props: {
    toggle: {
      type: Boolean,
      require: true,
    },
  },
  setup(props) {
    const toggle = useVModel(props, "toggle");

    return {
      toggle,
    };
  },
};
</script>

<style scoped lang="scss">
.item-frame {
  text-align: center;
  margin-bottom: 10px;
}
.switch {
  position: relative;
  &:before,
  &:after {
    content: "";
    vertical-align: middle;
    display: inline-block;
  }
  &:before {
    width: 2em;
    height: 1em;
    border: 2px solid #e0e0e0;
    border-radius: 32px;
    background: #999;
  }
  &:after {
    position: relative;
    width: 1em;
    height: 1em;
    background: #e0e0e0;
    border-radius: 50%;
    left: -2.2em;
  }
}
input {
  display: none;
  &:checked {
    ~ .switch {
      &:before {
        background: #7dc270;
        border-color: #7dc270;
      }
      &:after {
        left: -1.1em;
      }
    }
  }
}
</style>
